import { gtmApiHelper } from "../gtm/gtm-api-helper";

export async function useAddToWishListEffect(viewData, cost, licenType) {
  await gtmApiHelper.add_to_wishlist(viewData, cost, licenType);
}